import { Route, Routes } from "react-router-dom";
import { AppointmentConfirmPage } from "src/features/appointment/pages/AppointmentConfirmPage/AppointmentConfirmPage";
import { AppointmentDeletePage } from "src/features/appointment/pages/AppointmentDeletePage/AppointmentDeletePage";
import { AppointmentPage } from "src/features/appointment/pages/AppointmentPage/AppointmentPage";
import { ActivatePage } from "src/features/auth/pages/ActivatePage/ActivatePage";
import { LoginPage } from "src/features/auth/pages/LoginPage/LoginPage";
import { ProfileDeletePage } from "src/features/auth/pages/ProfileDeletePage/ProfileDeletePage";
import ProfilePage from "src/features/auth/pages/ProfilePage/ProfilePage";
import { RegisterPage } from "src/features/auth/pages/RegisterPage/RegisterPage";
import { ResetPasswordPage } from "src/features/auth/pages/ResetPasswordPage/ResetPasswordPage";
import HomePage from "src/features/home/pages/HomePage/HomePage";
import LandingPage from "src/features/landing/pages/LandingPage/LandingPage";
import "./AppContent.css";

export function AppContent() {
  return (
    <div className="appContent flex flex-auto">
      <div className="router">
        <Routes>
          <Route
            path="/"
            element={<LandingPage />}
          />

          <Route
            path="/login"
            element={<LoginPage />}
          />
          <Route
            path="/register"
            element={<RegisterPage />}
          />
          <Route
            path="/activate"
            element={<ActivatePage />}
          />
          <Route
            path="/resetpassword"
            element={<ResetPasswordPage />}
          />

          <Route
            path="/home"
            element={<HomePage />}
          />
          <Route
            path="/profile"
            element={<ProfilePage />}
          />
          <Route
            path="/profiledelete"
            element={<ProfileDeletePage />}
          />

          <Route
            path="/appointment"
            element={<AppointmentPage />}
          />
          <Route
            path="/appointment/confirm"
            element={<AppointmentConfirmPage />}
          />
          <Route
            path="/appointment/delete"
            element={<AppointmentDeletePage />}
          />
        </Routes>
      </div>
    </div>
  );
}
